import { Action } from '@ngrx/store';
import { Navigation } from '@digitaix/types';

export enum NavigationActionTypes {
  SetNavigationConfig = '[Navigation] Set Navigation Config',
}

export class SetNavigationConfig implements Action {
  readonly type = NavigationActionTypes.SetNavigationConfig;

  constructor(public config: Navigation) {}
}

export type NavigationActions = SetNavigationConfig;
